// extracted by mini-css-extract-plugin
module.exports = {"stars":"_3o3r8nL"};